<script>
import PortNameForm from '@components/port-name/port-name-form.vue'
import { mapActions } from 'vuex'

export default {
  name: 'PortNameList',
  components: { PortNameForm },
  props: {
    portNames: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      form: {},
    }
  },
  methods: {
    ...mapActions('portName', ['deletePortName']),
    editPortName(portName) {
      this.form = Object.assign({}, portName)
    },
    removePortName(portName) {
      let message = confirm('Are you sure you want to delete the port name?')
      if (message) {
        this.deletePortName(portName)
      }
    },
  },
}
</script>
<template>
  <div class="col card">
    <PortNameForm :form="form" />
    <table class="table card-body">
      <thead>
        <tr>
          <th>#</th>
          <th>Date</th>
          <th>Name</th>
          <th>Port Number</th>
          <th>Email</th>
          <th>Description</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody v-if="portNames.length">
        <tr v-for="(portName, index) in portNames" :key="portName.id">
          <td>{{ index + 1 }}</td>
          <th>{{ portName.createdDate }}</th>
          <td>{{ portName.name }}</td>
          <td>{{ portName.portNumber }}</td>
          <td>{{ portName.email }}</td>
          <td>{{ portName.description }}</td>
          <td>
            <span class="mr-1 badge badge-soft-success"
              ><a
                :id="`edit_port_name_${portName.id}`"
                href="javascript:void(0)"
                class="uil uil-edit"
                @click.stop="editPortName(portName)"
              ></a
            ></span>
            <span class="badge badge-soft-danger"
              ><a
                href="javascript:void(0)"
                class="uil uil-trash"
                @click.stop="removePortName(portName)"
              ></a
            ></span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="7">No data found</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
